import React from 'react'
import { useSelector } from 'react-redux'

import CentreBlockModal from './accountBlock/CentreBlockModal'
import DemoModalManager from './demoOnBoarding/DemoModalManajer'

const OnBoardingModals = () => {
  const centreDetail = useSelector((state) => state.centres.centreProfile)
  const { blockedCentre } = useSelector((state) => state.centres)
  const isDemoStatus = centreDetail?.creationDate && centreDetail.status === 'demo'
  const isBlockedStatus = blockedCentre?.status

  return (
    <div>
      {isDemoStatus && <DemoModalManager centreCreationDate={centreDetail.creationDate} />}
      {isBlockedStatus && <CentreBlockModal centreDetail={centreDetail} />}
    </div>
  )
}

export default OnBoardingModals
